import { render } from "./ArrowButton.vue?vue&type=template&id=4959c3be&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"

import "./ArrowButton.vue?vue&type=style&index=0&id=4959c3be&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/titans-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4959c3be"]])

export default __exports__